import ue from "jwt-decode";
import { createMachine as O, send as T, assign as h, interpret as P } from "xstate";
import q from "js-cookie";
import le from "axios";
const N = "nhostRefreshToken", D = "nhostRefreshTokenExpiresAt", de = 3, he = 300, z = 5, ee = 0, re = 1, S = 10, C = 20;
class M extends Error {
  constructor(e) {
    super(e.message), Error.captureStackTrace(this, this.constructor), e instanceof Error ? (this.name = e.name, this.error = {
      error: e.name,
      status: re,
      message: e.message
    }) : (this.name = e.error, this.error = e);
  }
}
const A = {
  status: S,
  error: "invalid-email",
  message: "Email is incorrectly formatted"
}, fe = {
  status: S,
  error: "invalid-mfa-type",
  message: "MFA type is invalid"
}, me = {
  status: S,
  error: "invalid-mfa-code",
  message: "MFA code is invalid"
}, $ = {
  status: S,
  error: "invalid-password",
  message: "Password is incorrectly formatted"
}, B = {
  status: S,
  error: "invalid-phone-number",
  message: "Phone number is incorrectly formatted"
}, Ee = {
  status: S,
  error: "invalid-mfa-ticket",
  message: "MFA ticket is invalid"
}, ge = {
  status: S,
  error: "no-mfa-ticket",
  message: "No MFA ticket has been provided"
}, pe = {
  status: S,
  error: "no-refresh-token",
  message: "No refresh token has been provided"
}, we = {
  status: C,
  error: "refresher-already-running",
  message: "The token refresher is already running. You must wait until is has finished before submitting a new token."
}, v = {
  status: C,
  error: "already-signed-in",
  message: "User is already signed in"
}, Te = {
  status: C,
  error: "unauthenticated-user",
  message: "User is not authenticated"
}, sr = {
  status: C,
  error: "user-not-anonymous",
  message: "User is not anonymous"
}, ye = {
  status: C,
  error: "unverified-user",
  message: "Email needs verification"
}, Se = {
  status: S,
  error: "invalid-refresh-token",
  message: "Invalid or expired refresh token"
}, ke = {
  status: re,
  error: "invalid-sign-in-method",
  message: "Invalid sign-in method"
}, L = {
  user: null,
  mfa: null,
  accessToken: {
    value: null,
    expiresAt: null
  },
  refreshTimer: {
    startedAt: null,
    attempts: 0,
    lastAttempt: null
  },
  refreshToken: {
    value: null
  },
  importTokenAttempts: 0,
  errors: {}
};
function ve(s) {
  return new TextEncoder().encode(s);
}
function R(s) {
  const e = new Uint8Array(s);
  let t = "";
  for (const n of e)
    t += String.fromCharCode(n);
  return btoa(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function H(s) {
  const e = s.replace(/-/g, "+").replace(/_/g, "/"), t = (4 - e.length % 4) % 4, r = e.padEnd(e.length + t, "="), n = atob(r), i = new ArrayBuffer(n.length), c = new Uint8Array(i);
  for (let l = 0; l < n.length; l++)
    c[l] = n.charCodeAt(l);
  return i;
}
function te() {
  return (window == null ? void 0 : window.PublicKeyCredential) !== void 0 && typeof window.PublicKeyCredential == "function";
}
function se(s) {
  const { id: e } = s;
  return {
    ...s,
    id: H(e),
    transports: s.transports
  };
}
function ne(s) {
  return s === "localhost" || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(s);
}
class w extends Error {
  constructor(e, t = "WebAuthnError") {
    super(e), this.name = t;
  }
}
function Ae({ error: s, options: e }) {
  var t, r;
  const { publicKey: n } = e;
  if (!n)
    throw Error("options was missing required publicKey property");
  if (s.name === "AbortError") {
    if (e.signal === new AbortController().signal)
      return new w("Registration ceremony was sent an abort signal", "AbortError");
  } else if (s.name === "ConstraintError") {
    if (((t = n.authenticatorSelection) === null || t === void 0 ? void 0 : t.requireResidentKey) === !0)
      return new w("Discoverable credentials were required but no available authenticator supported it", "ConstraintError");
    if (((r = n.authenticatorSelection) === null || r === void 0 ? void 0 : r.userVerification) === "required")
      return new w("User verification was required but no available authenticator supported it", "ConstraintError");
  } else {
    if (s.name === "InvalidStateError")
      return new w("The authenticator was previously registered", "InvalidStateError");
    if (s.name === "NotAllowedError")
      return new w("User clicked cancel, or the registration ceremony timed out", "NotAllowedError");
    if (s.name === "NotSupportedError")
      return n.pubKeyCredParams.filter((c) => c.type === "public-key").length === 0 ? new w('No entry in pubKeyCredParams was of type "public-key"', "NotSupportedError") : new w("No available authenticator supported any of the specified pubKeyCredParams algorithms", "NotSupportedError");
    if (s.name === "SecurityError") {
      const i = window.location.hostname;
      if (ne(i)) {
        if (n.rp.id !== i)
          return new w(`The RP ID "${n.rp.id}" is invalid for this domain`, "SecurityError");
      } else
        return new w(`${window.location.hostname} is an invalid domain`, "SecurityError");
    } else if (s.name === "TypeError") {
      if (n.user.id.byteLength < 1 || n.user.id.byteLength > 64)
        return new w("User ID was not between 1 and 64 characters", "TypeError");
    } else if (s.name === "UnknownError")
      return new w("The authenticator was unable to process the specified options, or could not create a new credential", "UnknownError");
  }
  return s;
}
class Ie {
  createNewAbortSignal() {
    return this.controller && this.controller.abort(), this.controller = new AbortController(), this.controller.signal;
  }
  reset() {
    this.controller = void 0;
  }
}
const V = new Ie();
async function ie(s) {
  if (!te())
    throw new Error("WebAuthn is not supported in this browser");
  const t = { publicKey: {
    ...s,
    challenge: H(s.challenge),
    user: {
      ...s.user,
      id: ve(s.user.id)
    },
    excludeCredentials: s.excludeCredentials.map(se)
  } };
  t.signal = V.createNewAbortSignal();
  let r;
  try {
    r = await navigator.credentials.create(t);
  } catch (g) {
    throw Ae({ error: g, options: t });
  } finally {
    V.reset();
  }
  if (!r)
    throw new Error("Registration was not completed");
  const { id: n, rawId: i, response: c, type: l } = r, m = {
    id: n,
    rawId: R(i),
    response: {
      attestationObject: R(c.attestationObject),
      clientDataJSON: R(c.clientDataJSON)
    },
    type: l,
    clientExtensionResults: r.getClientExtensionResults(),
    authenticatorAttachment: r.authenticatorAttachment
  };
  return typeof c.getTransports == "function" && (m.transports = c.getTransports()), m;
}
function _e(s) {
  return new TextDecoder("utf-8").decode(s);
}
async function Re() {
  if (navigator.credentials.conditionalMediationSupported)
    return !0;
  const s = window.PublicKeyCredential;
  return s.isConditionalMediationAvailable !== void 0 && s.isConditionalMediationAvailable();
}
function be({ error: s, options: e }) {
  var t;
  const { publicKey: r } = e;
  if (!r)
    throw Error("options was missing required publicKey property");
  if (s.name === "AbortError") {
    if (e.signal === new AbortController().signal)
      return new w("Authentication ceremony was sent an abort signal", "AbortError");
  } else {
    if (s.name === "NotAllowedError")
      return !((t = r.allowCredentials) === null || t === void 0) && t.length ? new w("No available authenticator recognized any of the allowed credentials", "NotAllowedError") : new w("User clicked cancel, or the authentication ceremony timed out", "NotAllowedError");
    if (s.name === "SecurityError") {
      const n = window.location.hostname;
      if (ne(n)) {
        if (r.rpId !== n)
          return new w(`The RP ID "${r.rpId}" is invalid for this domain`, "SecurityError");
      } else
        return new w(`${window.location.hostname} is an invalid domain`, "SecurityError");
    } else if (s.name === "UnknownError")
      return new w("The authenticator was unable to process the specified options, or could not create a new assertion signature", "UnknownError");
  }
  return s;
}
async function Oe(s, e = !1) {
  var t, r;
  if (!te())
    throw new Error("WebAuthn is not supported in this browser");
  let n;
  ((t = s.allowCredentials) === null || t === void 0 ? void 0 : t.length) !== 0 && (n = (r = s.allowCredentials) === null || r === void 0 ? void 0 : r.map(se));
  const i = {
    ...s,
    challenge: H(s.challenge),
    allowCredentials: n
  }, c = {};
  if (e) {
    if (!await Re())
      throw Error("Browser does not support WebAuthn autofill");
    if (document.querySelectorAll("input[autocomplete*='webauthn']").length < 1)
      throw Error('No <input> with `"webauthn"` in its `autocomplete` attribute was detected');
    c.mediation = "conditional", i.allowCredentials = [];
  }
  c.publicKey = i, c.signal = V.createNewAbortSignal();
  let l;
  try {
    l = await navigator.credentials.get(c);
  } catch (o) {
    throw be({ error: o, options: c });
  } finally {
    V.reset();
  }
  if (!l)
    throw new Error("Authentication was not completed");
  const { id: m, rawId: g, response: p, type: k } = l;
  let f;
  return p.userHandle && (f = _e(p.userHandle)), {
    id: m,
    rawId: R(g),
    response: {
      authenticatorData: R(p.authenticatorData),
      clientDataJSON: R(p.clientDataJSON),
      signature: R(p.signature),
      userHandle: f
    },
    type: k,
    clientExtensionResults: l.getClientExtensionResults(),
    authenticatorAttachment: l.authenticatorAttachment
  };
}
const G = typeof window < "u", K = /* @__PURE__ */ new Map(), Pe = (s) => G && typeof localStorage < "u" ? localStorage.getItem(s) : K.get(s) ?? null, Ce = (s, e) => {
  G && typeof localStorage < "u" ? e ? localStorage.setItem(s, e) : localStorage.removeItem(s) : e ? K.set(s, e) : K.has(s) && K.delete(s);
}, Ne = (s, e) => {
  if (s === "localStorage" || s === "web")
    return Pe;
  if (s === "cookie")
    return (t) => G ? q.get(t) ?? null : null;
  if (!e)
    throw Error(
      `clientStorageType is set to '${s}' but no clientStorage has been given`
    );
  if (s === "react-native")
    return (t) => {
      var r;
      return (r = e.getItem) == null ? void 0 : r.call(e, t);
    };
  if (s === "capacitor")
    return (t) => {
      var r;
      return (r = e.get) == null ? void 0 : r.call(e, { key: t });
    };
  if (s === "expo-secure-storage")
    return (t) => {
      var r;
      return (r = e.getItemAsync) == null ? void 0 : r.call(e, t);
    };
  if (s === "custom") {
    if (e.getItem && e.removeItem)
      return e.getItem;
    if (e.getItemAsync)
      return e.getItemAsync;
    throw Error(
      `clientStorageType is set to 'custom' but clientStorage is missing either "getItem" and "removeItem" properties or "getItemAsync" property`
    );
  }
  throw Error(`Unknown storage type: ${s}`);
}, De = (s, e) => {
  if (s === "localStorage" || s === "web")
    return Ce;
  if (s === "cookie")
    return (t, r) => {
      G && (r ? q.set(t, r, { expires: 30, sameSite: "lax", httpOnly: !1 }) : q.remove(t));
    };
  if (!e)
    throw Error(
      `clientStorageType is set to '${s}' but no clienStorage has been given`
    );
  if (s === "react-native")
    return (t, r) => {
      var n, i;
      return r ? (n = e.setItem) == null ? void 0 : n.call(e, t, r) : (i = e.removeItem) == null ? void 0 : i.call(e, t);
    };
  if (s === "capacitor")
    return (t, r) => {
      var n, i;
      return r ? (n = e.set) == null ? void 0 : n.call(e, { key: t, value: r }) : (i = e.remove) == null ? void 0 : i.call(e, { key: t });
    };
  if (s === "expo-secure-storage")
    return async (t, r) => {
      var n, i;
      return r ? (n = e.setItemAsync) == null ? void 0 : n.call(e, t, r) : (i = e.deleteItemAsync) == null ? void 0 : i.call(e, t);
    };
  if (s === "custom") {
    if (!e.removeItem)
      throw Error(
        "clientStorageType is set to 'custom' but clientStorage is missing a removeItem property"
      );
    if (e.setItem)
      return (t, r) => {
        var n, i;
        return r ? (n = e.setItem) == null ? void 0 : n.call(e, t, r) : (i = e.removeItem) == null ? void 0 : i.call(e, t);
      };
    if (e.setItemAsync)
      return async (t, r) => {
        var n, i;
        return r ? (n = e.setItemAsync) == null ? void 0 : n.call(e, t, r) : (i = e.removeItem) == null ? void 0 : i.call(e, t);
      };
    throw Error(
      "clientStorageType is set to 'custom' but clientStorage is missing setItem or setItemAsync property"
    );
  }
  throw Error(`Unknown storage type: ${s}`);
}, b = (s) => {
  const e = le.create({ baseURL: s });
  return e.interceptors.response.use(
    (t) => t,
    (t) => {
      var r, n, i, c, l, m, g;
      return Promise.reject({
        error: {
          message: ((n = (r = t.response) == null ? void 0 : r.data) == null ? void 0 : n.message) ?? t.message ?? t.request.responseText ?? JSON.stringify(t),
          status: ((i = t.response) == null ? void 0 : i.status) ?? ((l = (c = t.response) == null ? void 0 : c.data) == null ? void 0 : l.statusCode) ?? ee,
          error: ((g = (m = t.response) == null ? void 0 : m.data) == null ? void 0 : g.error) || t.request.statusText || "network"
        }
      });
    }
  ), e;
}, x = (s) => !s || !s.accessToken.value || !s.refreshToken.value || !s.accessToken.expiresAt || !s.user ? null : {
  accessToken: s.accessToken.value,
  accessTokenExpiresIn: (s.accessToken.expiresAt.getTime() - Date.now()) / 1e3,
  refreshToken: s.refreshToken.value,
  user: s.user
}, _ = ({
  accessToken: s,
  isError: e,
  user: t,
  error: r
}) => e ? {
  session: null,
  error: r
} : t && s ? {
  session: { accessToken: s, accessTokenExpiresIn: 0, refreshToken: "", user: t },
  error: null
} : { session: null, error: null }, W = () => typeof window < "u", oe = (s, e) => {
  const t = e && Object.entries(e).map(([r, n]) => {
    const i = Array.isArray(n) ? n.join(",") : typeof n == "object" ? JSON.stringify(n) : n;
    return `${r}=${encodeURIComponent(i)}`;
  }).join("&");
  return t ? `${s}?${t}` : s;
}, y = (s, e) => {
  if (!(e != null && e.redirectTo))
    return e;
  const { redirectTo: t, ...r } = e;
  if (!s)
    return t.startsWith("/") ? r : e;
  const n = new URL(s), i = Object.fromEntries(new URLSearchParams(n.search)), c = new URL(t.startsWith("/") ? n.origin + t : t), l = new URLSearchParams(c.search);
  let m = Object.fromEntries(l);
  t.startsWith("/") && (m = { ...i, ...m });
  let g = n.pathname;
  return c.pathname.length > 1 && (g += c.pathname.slice(1)), {
    ...r,
    redirectTo: oe(c.origin + g, m)
  };
};
function U(s, e) {
  var n;
  if (!e) {
    if (typeof window > "u")
      return;
    e = ((n = window.location) == null ? void 0 : n.href) || "";
  }
  s = s.replace(/[\[\]]/g, "\\$&");
  const t = new RegExp("[?&#]" + s + "(=([^&#]*)|&|#|$)"), r = t.exec(e);
  return r ? r[2] ? decodeURIComponent(r[2].replace(/\+/g, " ")) : "" : null;
}
function F(s) {
  var t;
  if (typeof window > "u")
    return;
  const e = window == null ? void 0 : window.location;
  if (e && e) {
    const r = new URLSearchParams(e.search), n = new URLSearchParams((t = e.hash) == null ? void 0 : t.slice(1));
    r.delete(s), n.delete(s);
    let i = window.location.pathname;
    Array.from(r).length && (i += `?${r.toString()}`), Array.from(n).length && (i += `#${n.toString()}`), window.history.pushState({}, "", i);
  }
}
const I = (s) => !!s && typeof s == "string" && !!String(s).toLowerCase().match(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
), j = (s) => !!s && typeof s == "string" && s.length >= de, Q = (s) => !!s && typeof s == "string", xe = (s) => s && typeof s == "string" && s.match(/^mfaTotp:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i), Ue = ({
  backendUrl: s,
  clientUrl: e,
  clientStorageGetter: t,
  clientStorageSetter: r,
  clientStorageType: n = "web",
  clientStorage: i,
  refreshIntervalTime: c,
  autoRefreshToken: l = !0,
  autoSignIn: m = !0
}) => {
  const g = t || Ne(n, i), p = r || De(n, i), k = b(s), f = async (o, a, u) => (await k.post(o, a, u)).data;
  return O(
    {
      schema: {
        context: {},
        events: {},
        services: {}
      },
      tsTypes: {},
      context: L,
      predictableActionArguments: !0,
      id: "nhost",
      type: "parallel",
      states: {
        authentication: {
          initial: "starting",
          on: {
            SESSION_UPDATE: [
              {
                cond: "hasSession",
                actions: ["saveSession", "resetTimer", "reportTokenChanged"],
                target: ".signedIn"
              }
            ]
          },
          states: {
            starting: {
              tags: ["loading"],
              always: { cond: "isSignedIn", target: "signedIn" },
              invoke: {
                id: "importRefreshToken",
                src: "importRefreshToken",
                onDone: [
                  {
                    cond: "hasSession",
                    actions: ["saveSession", "reportTokenChanged"],
                    target: "signedIn"
                  },
                  {
                    target: "signedOut"
                  }
                ],
                onError: [
                  {
                    cond: "shouldRetryImportToken",
                    actions: "incrementTokenImportAttempts",
                    target: "retryTokenImport"
                  },
                  { actions: ["saveAuthenticationError"], target: "signedOut" }
                ]
              }
            },
            retryTokenImport: {
              tags: ["loading"],
              after: {
                RETRY_IMPORT_TOKEN_DELAY: "starting"
              }
            },
            signedOut: {
              initial: "noErrors",
              entry: "reportSignedOut",
              states: {
                noErrors: {},
                success: {},
                needsSmsOtp: {},
                needsMfa: {},
                failed: {},
                signingOut: {
                  entry: ["clearContextExceptRefreshToken"],
                  exit: ["destroyRefreshToken", "reportTokenChanged"],
                  invoke: {
                    src: "signout",
                    id: "signingOut",
                    onDone: {
                      target: "success"
                    },
                    onError: {
                      target: "failed",
                      actions: ["saveAuthenticationError"]
                    }
                  }
                }
              },
              on: {
                SIGNIN_PASSWORD: "authenticating.password",
                SIGNIN_ANONYMOUS: "authenticating.anonymous",
                SIGNIN_SECURITY_KEY_EMAIL: "authenticating.securityKeyEmail",
                SIGNIN_MFA_TOTP: "authenticating.mfa.totp"
              }
            },
            authenticating: {
              entry: "resetErrors",
              states: {
                password: {
                  invoke: {
                    src: "signInPassword",
                    id: "authenticateUserWithPassword",
                    onDone: [
                      {
                        cond: "hasMfaTicket",
                        actions: ["saveMfaTicket"],
                        target: "#nhost.authentication.signedOut.needsMfa"
                      },
                      {
                        actions: ["saveSession", "reportTokenChanged"],
                        target: "#nhost.authentication.signedIn"
                      }
                    ],
                    onError: [
                      {
                        cond: "unverified",
                        target: [
                          "#nhost.authentication.signedOut",
                          "#nhost.registration.incomplete.needsEmailVerification"
                        ]
                      },
                      {
                        actions: "saveAuthenticationError",
                        target: "#nhost.authentication.signedOut.failed"
                      }
                    ]
                  }
                },
                anonymous: {
                  invoke: {
                    src: "signInAnonymous",
                    id: "authenticateAnonymously",
                    onDone: {
                      actions: ["saveSession", "reportTokenChanged"],
                      target: "#nhost.authentication.signedIn"
                    },
                    onError: {
                      actions: "saveAuthenticationError",
                      target: "#nhost.authentication.signedOut.failed"
                    }
                  }
                },
                mfa: {
                  states: {
                    totp: {
                      invoke: {
                        src: "signInMfaTotp",
                        id: "signInMfaTotp",
                        onDone: {
                          actions: ["saveSession", "reportTokenChanged"],
                          target: "#nhost.authentication.signedIn"
                        },
                        onError: {
                          actions: ["saveAuthenticationError"],
                          target: "#nhost.authentication.signedOut.failed"
                        }
                      }
                    }
                  }
                },
                securityKeyEmail: {
                  invoke: {
                    src: "signInSecurityKeyEmail",
                    id: "authenticateUserWithSecurityKey",
                    onDone: {
                      actions: ["saveSession", "reportTokenChanged"],
                      target: "#nhost.authentication.signedIn"
                    },
                    onError: [
                      {
                        cond: "unverified",
                        target: [
                          "#nhost.authentication.signedOut",
                          "#nhost.registration.incomplete.needsEmailVerification"
                        ]
                      },
                      {
                        actions: "saveAuthenticationError",
                        target: "#nhost.authentication.signedOut.failed"
                      }
                    ]
                  }
                }
              }
            },
            signedIn: {
              type: "parallel",
              entry: ["reportSignedIn", "cleanUrl", "broadcastToken", "resetErrors"],
              on: {
                SIGNOUT: "signedOut.signingOut"
              },
              states: {
                refreshTimer: {
                  id: "timer",
                  initial: "idle",
                  states: {
                    disabled: { type: "final" },
                    stopped: {
                      always: {
                        cond: "noToken",
                        target: "idle"
                      }
                    },
                    idle: {
                      always: [
                        { cond: "isAutoRefreshDisabled", target: "disabled" },
                        {
                          cond: "hasRefreshToken",
                          target: "running"
                        }
                      ]
                    },
                    running: {
                      initial: "pending",
                      entry: "resetTimer",
                      states: {
                        pending: {
                          after: {
                            1e3: {
                              internal: !1,
                              target: "pending"
                            }
                          },
                          always: {
                            cond: "refreshTimerShouldRefresh",
                            target: "refreshing"
                          }
                        },
                        refreshing: {
                          invoke: {
                            src: "refreshToken",
                            id: "refreshToken",
                            onDone: {
                              actions: ["saveSession", "resetTimer", "reportTokenChanged"],
                              target: "pending"
                            },
                            onError: [{ actions: "saveRefreshAttempt", target: "pending" }]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        },
        token: {
          initial: "idle",
          states: {
            idle: {
              on: {
                TRY_TOKEN: "running"
              },
              initial: "noErrors",
              states: { noErrors: {}, error: {} }
            },
            running: {
              invoke: {
                src: "refreshToken",
                id: "authenticateWithToken",
                onDone: {
                  actions: ["saveSession", "reportTokenChanged"],
                  target: ["#nhost.authentication.signedIn", "idle.noErrors"]
                },
                onError: [
                  { cond: "isSignedIn", target: "idle.error" },
                  {
                    actions: "saveAuthenticationError",
                    target: ["#nhost.authentication.signedOut.failed", "idle.error"]
                  }
                ]
              }
            }
          }
        },
        registration: {
          initial: "incomplete",
          on: {
            SIGNED_IN: [{ cond: "isAnonymous", target: ".incomplete" }, ".complete"]
          },
          states: {
            incomplete: {
              on: {
                SIGNUP_EMAIL_PASSWORD: "emailPassword",
                SIGNUP_SECURITY_KEY: "securityKey",
                PASSWORDLESS_EMAIL: "passwordlessEmail",
                PASSWORDLESS_SMS: "passwordlessSms",
                PASSWORDLESS_SMS_OTP: "passwordlessSmsOtp"
              },
              initial: "noErrors",
              states: {
                noErrors: {},
                needsEmailVerification: {},
                needsOtp: {},
                failed: {}
              }
            },
            emailPassword: {
              entry: ["resetErrors"],
              invoke: {
                src: "signUpEmailPassword",
                id: "signUpEmailPassword",
                onDone: [
                  {
                    cond: "hasSession",
                    actions: ["saveSession", "reportTokenChanged"],
                    target: "#nhost.authentication.signedIn"
                  },
                  {
                    actions: "clearContext",
                    target: ["#nhost.authentication.signedOut", "incomplete.needsEmailVerification"]
                  }
                ],
                onError: [
                  {
                    cond: "unverified",
                    target: "incomplete.needsEmailVerification"
                  },
                  {
                    actions: "saveRegistrationError",
                    target: "incomplete.failed"
                  }
                ]
              }
            },
            securityKey: {
              entry: ["resetErrors"],
              invoke: {
                src: "signUpSecurityKey",
                id: "signUpSecurityKey",
                onDone: [
                  {
                    cond: "hasSession",
                    actions: ["saveSession", "reportTokenChanged"],
                    target: "#nhost.authentication.signedIn"
                  },
                  {
                    actions: "clearContext",
                    target: ["#nhost.authentication.signedOut", "incomplete.needsEmailVerification"]
                  }
                ],
                onError: [
                  {
                    cond: "unverified",
                    target: "incomplete.needsEmailVerification"
                  },
                  {
                    actions: "saveRegistrationError",
                    target: "incomplete.failed"
                  }
                ]
              }
            },
            passwordlessEmail: {
              entry: ["resetErrors"],
              invoke: {
                src: "passwordlessEmail",
                id: "passwordlessEmail",
                onDone: {
                  actions: "clearContext",
                  target: ["#nhost.authentication.signedOut", "incomplete.needsEmailVerification"]
                },
                onError: {
                  actions: "saveRegistrationError",
                  target: "incomplete.failed"
                }
              }
            },
            passwordlessSms: {
              entry: ["resetErrors"],
              invoke: {
                src: "passwordlessSms",
                id: "passwordlessSms",
                onDone: {
                  actions: "clearContext",
                  target: ["#nhost.authentication.signedOut", "incomplete.needsOtp"]
                },
                onError: {
                  actions: "saveRegistrationError",
                  target: "incomplete.failed"
                }
              }
            },
            passwordlessSmsOtp: {
              entry: ["resetErrors"],
              invoke: {
                src: "passwordlessSmsOtp",
                id: "passwordlessSmsOtp",
                onDone: {
                  actions: ["saveSession", "reportTokenChanged"],
                  target: "#nhost.authentication.signedIn"
                },
                onError: {
                  actions: "saveRegistrationError",
                  target: "incomplete.failed"
                }
              }
            },
            complete: {
              on: {
                SIGNED_OUT: "incomplete"
              }
            }
          }
        }
      }
    },
    {
      actions: {
        reportSignedIn: T("SIGNED_IN"),
        reportSignedOut: T("SIGNED_OUT"),
        reportTokenChanged: T("TOKEN_CHANGED"),
        incrementTokenImportAttempts: h({
          importTokenAttempts: ({ importTokenAttempts: o }) => o + 1
        }),
        clearContext: h(() => (p(D, null), p(N, null), {
          ...L
        })),
        clearContextExceptRefreshToken: h(({ refreshToken: { value: o } }) => (p(D, null), {
          ...L,
          refreshToken: { value: o }
        })),
        saveSession: h({
          user: (o, { data: a }) => {
            var u;
            return ((u = a == null ? void 0 : a.session) == null ? void 0 : u.user) || null;
          },
          accessToken: (o, { data: a }) => {
            if (a.session) {
              const { accessTokenExpiresIn: u, accessToken: d } = a.session, E = new Date(Date.now() + u * 1e3);
              return p(D, E.toISOString()), {
                value: d,
                expiresAt: E
              };
            }
            return p(D, null), {
              value: null,
              expiresAt: null
            };
          },
          refreshToken: (o, { data: a }) => {
            var d;
            const u = ((d = a.session) == null ? void 0 : d.refreshToken) || null;
            return u && p(N, u), { value: u };
          }
        }),
        saveMfaTicket: h({
          mfa: (o, a) => {
            var u;
            return (u = a.data) == null ? void 0 : u.mfa;
          }
        }),
        resetTimer: h({
          refreshTimer: (o) => ({
            startedAt: new Date(),
            attempts: 0,
            lastAttempt: null
          })
        }),
        saveRefreshAttempt: h({
          refreshTimer: (o, a) => ({
            startedAt: o.refreshTimer.startedAt,
            attempts: o.refreshTimer.attempts + 1,
            lastAttempt: new Date()
          })
        }),
        saveAuthenticationError: h({
          errors: ({ errors: o }, { data: { error: a } }) => ({
            ...o,
            authentication: a
          })
        }),
        resetErrors: h({
          errors: (o) => ({}),
          importTokenAttempts: (o) => 0
        }),
        saveRegistrationError: h({
          errors: ({ errors: o }, { data: { error: a } }) => ({ ...o, registration: a })
        }),
        destroyRefreshToken: h({
          refreshToken: (o) => (p(N, null), { value: null })
        }),
        cleanUrl: () => {
          m && U("refreshToken") && (F("refreshToken"), F("type"));
        },
        broadcastToken: (o) => {
          if (m)
            try {
              new BroadcastChannel("nhost").postMessage(o.refreshToken.value);
            } catch {
            }
        }
      },
      guards: {
        isAnonymous: (o, a) => {
          var u;
          return !!((u = o.user) != null && u.isAnonymous);
        },
        isSignedIn: (o) => !!o.user && !!o.refreshToken.value && !!o.accessToken.value,
        noToken: (o) => !o.refreshToken.value,
        hasRefreshToken: (o) => !!o.refreshToken.value,
        isAutoRefreshDisabled: () => !l,
        refreshTimerShouldRefresh: (o) => {
          const { expiresAt: a } = o.accessToken;
          return a ? o.refreshTimer.lastAttempt ? o.refreshTimer.attempts > z ? !1 : Date.now() - o.refreshTimer.lastAttempt.getTime() > Math.pow(2, o.refreshTimer.attempts - 1) * 5e3 : c && Date.now() - o.refreshTimer.startedAt.getTime() > c * 1e3 ? !0 : a.getTime() - Date.now() - 1e3 * he <= 0 : !1;
        },
        shouldRetryImportToken: (o, a) => o.importTokenAttempts < z && (a.data.error.status === ee || a.data.error.status >= 500),
        unverified: (o, { data: { error: a } }) => a.status === 401 && (a.message === "Email is not verified" || a.error === "unverified-user"),
        hasSession: (o, a) => {
          var u;
          return !!((u = a.data) != null && u.session);
        },
        hasMfaTicket: (o, a) => {
          var u;
          return !!((u = a.data) != null && u.mfa);
        }
      },
      services: {
        signInPassword: (o, { email: a, password: u }) => I(a) ? j(u) ? f("/signin/email-password", {
          email: a,
          password: u
        }) : Promise.reject({ error: $ }) : Promise.reject({ error: A }),
        passwordlessSms: (o, { phoneNumber: a, options: u }) => {
          var d;
          return Q(a) ? (d = o.user) != null && d.isAnonymous ? (console.warn(
            "Deanonymisation from a phone number is not yet implemented in hasura-auth"
          ), f(
            "/user/deanonymize",
            {
              signInMethod: "passwordless",
              connection: "sms",
              phoneNumber: a,
              options: y(e, u)
            },
            {
              headers: {
                authorization: `Bearer ${o.accessToken.value}`
              }
            }
          )) : f("/signin/passwordless/sms", {
            phoneNumber: a,
            options: y(e, u)
          }) : Promise.reject({ error: B });
        },
        passwordlessSmsOtp: (o, { phoneNumber: a, otp: u }) => Q(a) ? f("/signin/passwordless/sms/otp", {
          phoneNumber: a,
          otp: u
        }) : Promise.reject({ error: B }),
        passwordlessEmail: (o, { email: a, options: u }) => {
          var d;
          return I(a) ? (d = o.user) != null && d.isAnonymous ? f(
            "/user/deanonymize",
            {
              signInMethod: "passwordless",
              connection: "email",
              email: a,
              options: y(e, u)
            },
            {
              headers: {
                authorization: `Bearer ${o.accessToken.value}`
              }
            }
          ) : f("/signin/passwordless/email", {
            email: a,
            options: y(e, u)
          }) : Promise.reject({ error: A });
        },
        signInAnonymous: (o) => f("/signin/anonymous"),
        signInMfaTotp: (o, a) => {
          var d;
          const u = a.ticket || ((d = o.mfa) == null ? void 0 : d.ticket);
          return u ? xe(u) ? f("/signin/mfa/totp", {
            ticket: u,
            otp: a.otp
          }) : Promise.reject({ error: Ee }) : Promise.reject({ error: ge });
        },
        signInSecurityKeyEmail: async (o, { email: a }) => {
          if (!I(a))
            throw new M(A);
          const u = await f(
            "/signin/webauthn",
            { email: a }
          );
          let d;
          try {
            d = await Oe(u);
          } catch (E) {
            throw new M(E);
          }
          return f("/signin/webauthn/verify", { email: a, credential: d });
        },
        refreshToken: async (o, a) => {
          const u = a.type === "TRY_TOKEN" ? a.token : o.refreshToken.value;
          return { session: await f("/token", {
            refreshToken: u
          }), error: null };
        },
        signout: (o, a) => f("/signout", {
          refreshToken: o.refreshToken.value,
          all: !!a.all
        }),
        signUpEmailPassword: async (o, { email: a, password: u, options: d }) => {
          var E;
          return I(a) ? j(u) ? (E = o.user) != null && E.isAnonymous ? f(
            "/user/deanonymize",
            {
              signInMethod: "email-password",
              email: a,
              password: u,
              options: y(e, d)
            },
            {
              headers: {
                authorization: `Bearer ${o.accessToken.value}`
              }
            }
          ) : f("/signup/email-password", {
            email: a,
            password: u,
            options: y(e, d)
          }) : Promise.reject({ error: $ }) : Promise.reject({ error: A });
        },
        signUpSecurityKey: async (o, { email: a, options: u }) => {
          if (!I(a))
            return Promise.reject({ error: A });
          const d = u == null ? void 0 : u.nickname;
          d && delete u.nickname;
          const E = await f(
            "/signup/webauthn",
            { email: a, options: u }
          );
          let Y;
          try {
            Y = await ie(E);
          } catch (ce) {
            throw new M(ce);
          }
          return f("/signup/webauthn/verify", {
            credential: Y,
            options: {
              redirectTo: u == null ? void 0 : u.redirectTo,
              nickname: d
            }
          });
        },
        importRefreshToken: async (o) => {
          if (o.user && o.refreshToken.value && o.accessToken.value && o.accessToken.expiresAt)
            return {
              session: {
                accessToken: o.accessToken.value,
                accessTokenExpiresIn: o.accessToken.expiresAt.getTime() - Date.now(),
                refreshToken: o.refreshToken.value,
                user: o.user
              },
              error: null
            };
          let a = null;
          if (m) {
            const d = U("refreshToken") || null;
            if (d)
              try {
                return { session: await f("/token", {
                  refreshToken: d
                }), error: null };
              } catch (E) {
                a = E.error;
              }
            else {
              const E = U("error");
              if (E)
                return Promise.reject({
                  session: null,
                  error: {
                    status: S,
                    error: E,
                    message: U("errorDescription") || E
                  }
                });
            }
          }
          const u = await g(N);
          if (u)
            try {
              return { session: await f("/token", {
                refreshToken: u
              }), error: null };
            } catch (d) {
              a = d.error;
            }
          return a ? Promise.reject({ error: a, session: null }) : { error: null, session: null };
        }
      },
      delays: {
        RETRY_IMPORT_TOKEN_DELAY: ({ importTokenAttempts: o }) => Math.pow(2, o - 1) * 5e3
      }
    }
  );
}, Me = ({ backendUrl: s, clientUrl: e, interpreter: t }) => {
  const r = b(s);
  return O(
    {
      schema: {
        context: {},
        events: {},
        services: {}
      },
      tsTypes: {},
      predictableActionArguments: !0,
      id: "changeEmail",
      initial: "idle",
      context: { error: null },
      states: {
        idle: {
          on: {
            REQUEST: [
              {
                cond: "invalidEmail",
                actions: "saveInvalidEmailError",
                target: ".error"
              },
              {
                target: "requesting"
              }
            ]
          },
          initial: "initial",
          states: {
            initial: {},
            success: {},
            error: {}
          }
        },
        requesting: {
          invoke: {
            src: "requestChange",
            id: "requestChange",
            onDone: { target: "idle.success", actions: "reportSuccess" },
            onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
          }
        }
      }
    },
    {
      actions: {
        saveInvalidEmailError: h({ error: (n) => A }),
        saveRequestError: h({
          error: (n, { data: { error: i } }) => i
        }),
        reportError: T((n) => ({ type: "ERROR", error: n.error })),
        reportSuccess: T("SUCCESS")
      },
      guards: {
        invalidEmail: (n, { email: i }) => !I(i)
      },
      services: {
        requestChange: async (n, { email: i, options: c }) => (await r.post(
          "/user/email/change",
          {
            newEmail: i,
            options: y(e, c)
          },
          {
            headers: {
              authorization: `Bearer ${t == null ? void 0 : t.getSnapshot().context.accessToken.value}`
            }
          }
        )).data
      }
    }
  );
}, Ke = ({ backendUrl: s, interpreter: e }) => {
  const t = b(s);
  return O(
    {
      schema: {
        context: {},
        events: {},
        services: {}
      },
      tsTypes: {},
      predictableActionArguments: !0,
      id: "changePassword",
      initial: "idle",
      context: { error: null },
      states: {
        idle: {
          on: {
            REQUEST: [
              {
                cond: "invalidPassword",
                actions: "saveInvalidPasswordError",
                target: ".error"
              },
              {
                target: "requesting"
              }
            ]
          },
          initial: "initial",
          states: {
            initial: {},
            success: {},
            error: {}
          }
        },
        requesting: {
          invoke: {
            src: "requestChange",
            id: "requestChange",
            onDone: { target: "idle.success", actions: "reportSuccess" },
            onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
          }
        }
      }
    },
    {
      actions: {
        saveInvalidPasswordError: h({ error: (r) => $ }),
        saveRequestError: h({
          error: (r, { data: { error: n } }) => n
        }),
        reportError: T((r) => ({ type: "ERROR", error: r.error })),
        reportSuccess: T("SUCCESS")
      },
      guards: {
        invalidPassword: (r, { password: n }) => !j(n)
      },
      services: {
        requestChange: (r, { password: n, ticket: i }) => t.post(
          "/user/password",
          { newPassword: n, ticket: i },
          {
            headers: {
              authorization: `Bearer ${e == null ? void 0 : e.getSnapshot().context.accessToken.value}`
            }
          }
        )
      }
    }
  );
}, nr = ({ backendUrl: s, interpreter: e }) => {
  const t = b(s);
  return O(
    {
      schema: {
        context: {},
        events: {}
      },
      tsTypes: {},
      predictableActionArguments: !0,
      id: "enableMfa",
      initial: "idle",
      context: { error: null, imageUrl: null, secret: null },
      states: {
        idle: {
          initial: "initial",
          on: {
            GENERATE: "generating"
          },
          states: {
            initial: {},
            error: {}
          }
        },
        generating: {
          invoke: {
            src: "generate",
            id: "generate",
            onDone: { target: "generated", actions: ["reportGeneratedSuccess", "saveGeneration"] },
            onError: { actions: ["saveError", "reportGeneratedError"], target: "idle.error" }
          }
        },
        generated: {
          initial: "idle",
          states: {
            idle: {
              initial: "idle",
              on: {
                ACTIVATE: [
                  {
                    cond: "invalidMfaType",
                    actions: "saveInvalidMfaTypeError",
                    target: ".error"
                  },
                  {
                    cond: "invalidMfaCode",
                    actions: "saveInvalidMfaCodeError",
                    target: ".error"
                  },
                  {
                    target: "activating"
                  }
                ]
              },
              states: { idle: {}, error: {} }
            },
            activating: {
              invoke: {
                src: "activate",
                id: "activate",
                onDone: { target: "activated", actions: "reportSuccess" },
                onError: { actions: ["saveError", "reportError"], target: "idle.error" }
              }
            },
            activated: { type: "final" }
          }
        }
      }
    },
    {
      actions: {
        saveInvalidMfaTypeError: h({ error: (r) => fe }),
        saveInvalidMfaCodeError: h({ error: (r) => me }),
        saveError: h({
          error: (r, { data: { error: n } }) => n
        }),
        saveGeneration: h({
          imageUrl: (r, { data: { imageUrl: n } }) => n,
          secret: (r, { data: { totpSecret: n } }) => n
        }),
        reportError: T((r) => ({ type: "ERROR", error: r.error })),
        reportSuccess: T("SUCCESS"),
        reportGeneratedSuccess: T("GENERATED"),
        reportGeneratedError: T((r) => ({ type: "GENERATED_ERROR", error: r.error }))
      },
      guards: {
        invalidMfaCode: (r, { code: n }) => !n,
        invalidMfaType: (r, { activeMfaType: n }) => !n || n !== "totp"
      },
      services: {
        generate: async (r) => {
          const { data: n } = await t.get("/mfa/totp/generate", {
            headers: {
              authorization: `Bearer ${e == null ? void 0 : e.getSnapshot().context.accessToken.value}`
            }
          });
          return n;
        },
        activate: (r, { code: n, activeMfaType: i }) => t.post(
          "/user/mfa",
          {
            code: n,
            activeMfaType: i
          },
          {
            headers: {
              authorization: `Bearer ${e == null ? void 0 : e.getSnapshot().context.accessToken.value}`
            }
          }
        )
      }
    }
  );
}, Ve = ({ backendUrl: s, clientUrl: e }) => {
  const t = b(s);
  return O(
    {
      schema: {
        context: {},
        events: {},
        services: {}
      },
      tsTypes: {},
      predictableActionArguments: !0,
      id: "changePassword",
      initial: "idle",
      context: { error: null },
      states: {
        idle: {
          on: {
            REQUEST: [
              {
                cond: "invalidEmail",
                actions: "saveInvalidEmailError",
                target: ".error"
              },
              {
                target: "requesting"
              }
            ]
          },
          initial: "initial",
          states: {
            initial: {},
            success: {},
            error: {}
          }
        },
        requesting: {
          invoke: {
            src: "requestChange",
            id: "requestChange",
            onDone: { target: "idle.success", actions: "reportSuccess" },
            onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
          }
        }
      }
    },
    {
      actions: {
        saveInvalidEmailError: h({ error: (r) => A }),
        saveRequestError: h({
          error: (r, { data: { error: n } }) => n
        }),
        reportError: T((r) => ({ type: "ERROR", error: r.error })),
        reportSuccess: T("SUCCESS")
      },
      guards: {
        invalidEmail: (r, { email: n }) => !I(n)
      },
      services: {
        requestChange: (r, { email: n, options: i }) => t.post("/user/password/reset", {
          email: n,
          options: y(e, i)
        })
      }
    }
  );
}, Ge = ({ backendUrl: s, clientUrl: e }) => {
  const t = b(s);
  return O(
    {
      schema: {
        context: {},
        events: {},
        services: {}
      },
      tsTypes: {},
      predictableActionArguments: !0,
      id: "sendVerificationEmail",
      initial: "idle",
      context: { error: null },
      states: {
        idle: {
          on: {
            REQUEST: [
              {
                cond: "invalidEmail",
                actions: "saveInvalidEmailError",
                target: ".error"
              },
              {
                target: "requesting"
              }
            ]
          },
          initial: "initial",
          states: {
            initial: {},
            success: {},
            error: {}
          }
        },
        requesting: {
          invoke: {
            src: "request",
            id: "request",
            onDone: { target: "idle.success", actions: "reportSuccess" },
            onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
          }
        }
      }
    },
    {
      actions: {
        saveInvalidEmailError: h({ error: (r) => A }),
        saveRequestError: h({
          error: (r, { data: { error: n } }) => n
        }),
        reportError: T((r) => ({ type: "ERROR", error: r.error })),
        reportSuccess: T("SUCCESS")
      },
      guards: {
        invalidEmail: (r, { email: n }) => !I(n)
      },
      services: {
        request: async (r, { email: n, options: i }) => (await t.post(
          "/user/email/send-verification-email",
          {
            email: n,
            options: y(e, i)
          }
        )).data
      }
    }
  );
};
class ae {
  constructor({
    clientStorageType: e = "web",
    autoSignIn: t = !0,
    autoRefreshToken: r = !0,
    start: n = !0,
    backendUrl: i,
    clientUrl: c,
    devTools: l,
    ...m
  }) {
    if (this._started = !1, this._subscriptionsQueue = /* @__PURE__ */ new Set(), this._subscriptions = /* @__PURE__ */ new Set(), this.backendUrl = i, this.clientUrl = c, this._machine = Ue({
      ...m,
      backendUrl: i,
      clientUrl: c,
      clientStorageType: e,
      autoSignIn: t,
      autoRefreshToken: r
    }), n && this.start({ devTools: l }), typeof window < "u" && t)
      try {
        this._channel = new BroadcastChannel("nhost"), this._channel.addEventListener("message", (g) => {
          var k;
          const p = (k = this.interpreter) == null ? void 0 : k.getSnapshot().context.refreshToken.value;
          this.interpreter && g.data !== p && this.interpreter.send("TRY_TOKEN", { token: g.data });
        });
      } catch {
      }
  }
  start({
    devTools: e = !1,
    initialSession: t,
    interpreter: r
  } = {}) {
    const n = { ...this.machine.context };
    t && (n.user = t.user, n.refreshToken.value = t.refreshToken ?? null, n.accessToken.value = t.accessToken ?? null, n.accessToken.expiresAt = new Date(
      Date.now() + t.accessTokenExpiresIn * 1e3
    ));
    const i = this.machine.withContext(n);
    this._interpreter || (this._interpreter = r || P(i, { devTools: e })), (!this._started || typeof window > "u") && (this._interpreter.initialized && (this._interpreter.stop(), this._subscriptions.forEach((c) => c())), this._interpreter.start(i.initialState), this._subscriptionsQueue.forEach((c) => c(this))), this._started = !0;
  }
  get machine() {
    return this._machine;
  }
  get interpreter() {
    return this._interpreter;
  }
  get started() {
    return this._started;
  }
  subscribe(e) {
    if (this.started) {
      const t = e(this);
      return this._subscriptions.add(t), t;
    } else
      return this._subscriptionsQueue.add(e), () => {
        console.log(
          "onTokenChanged was added before the interpreter started. Cannot unsubscribe listener."
        );
      };
  }
}
class Le extends ae {
  constructor({
    ...e
  }) {
    super({
      ...e,
      autoSignIn: W() && e.autoSignIn,
      autoRefreshToken: W() && e.autoRefreshToken,
      clientStorageType: "cookie"
    });
  }
}
const ir = Le, qe = async ({ backendUrl: s, interpreter: e }, t) => {
  const r = b(s);
  try {
    const { data: n } = await r.post(
      "/user/webauthn/add",
      {},
      {
        headers: {
          authorization: `Bearer ${e == null ? void 0 : e.getSnapshot().context.accessToken.value}`
        }
      }
    );
    let i;
    try {
      i = await ie(n);
    } catch (l) {
      throw new M(l);
    }
    const { data: c } = await r.post(
      "/user/webauthn/verify",
      { credential: i, nickname: t },
      {
        headers: {
          authorization: `Bearer ${e == null ? void 0 : e.getSnapshot().context.accessToken.value}`
        }
      }
    );
    return { key: c, isError: !1, error: null, isSuccess: !0 };
  } catch (n) {
    const { error: i } = n;
    return { isError: !0, error: i, isSuccess: !1 };
  }
}, $e = async (s, e, t) => new Promise((r) => {
  s.send("REQUEST", {
    email: e,
    options: t
  }), s.onTransition((n) => {
    n.matches({ idle: "error" }) ? r({ error: n.context.error, isError: !0, needsEmailVerification: !1 }) : n.matches({ idle: "success" }) && r({ error: null, isError: !1, needsEmailVerification: !0 });
  });
}), We = async (s, e, t) => new Promise((r) => {
  s.send("REQUEST", {
    password: e,
    ticket: t
  }), s.onTransition((n) => {
    n.matches({ idle: "error" }) ? r({ error: n.context.error, isError: !0, isSuccess: !1 }) : n.matches({ idle: "success" }) && r({ error: null, isError: !1, isSuccess: !0 });
  });
}), or = (s) => new Promise((e) => {
  s.send("GENERATE"), s.onTransition((t) => {
    t.matches("generated") ? e({
      error: null,
      isError: !1,
      isGenerated: !0,
      qrCodeDataUrl: t.context.imageUrl || ""
    }) : t.matches({ idle: "error" }) && e({
      error: t.context.error || null,
      isError: !0,
      isGenerated: !1,
      qrCodeDataUrl: ""
    });
  });
}), ar = (s, e) => new Promise((t) => {
  s.send("ACTIVATE", {
    activeMfaType: "totp",
    code: e
  }), s.onTransition((r) => {
    r.matches({ generated: "activated" }) ? t({ error: null, isActivated: !0, isError: !1 }) : r.matches({ generated: { idle: "error" } }) && t({ error: r.context.error, isActivated: !1, isError: !0 });
  });
}), je = async (s, e, t) => new Promise((r) => {
  s.send("REQUEST", {
    email: e,
    options: t
  }), s.onTransition((n) => {
    n.matches({ idle: "error" }) ? r({ error: n.context.error, isError: !0, isSent: !1 }) : n.matches({ idle: "success" }) && r({ error: null, isError: !1, isSent: !0 });
  });
}), He = (s, e, t) => new Promise((r) => {
  s.send("REQUEST", {
    email: e,
    options: t
  }), s.onTransition((n) => {
    n.matches({ idle: "error" }) ? r({ error: n.context.error, isError: !0, isSent: !1 }) : n.matches({ idle: "success" }) && r({ error: null, isError: !1, isSent: !0 });
  });
}), Ye = (s) => new Promise((e) => {
  const { changed: t } = s.send("SIGNIN_ANONYMOUS");
  t || e({
    isSuccess: !1,
    isError: !0,
    error: v,
    user: null,
    accessToken: null
  }), s.onTransition((r) => {
    r.matches({ authentication: "signedIn" }) && e({
      isSuccess: !0,
      isError: !1,
      error: null,
      user: r.context.user,
      accessToken: r.context.accessToken.value
    }), r.matches({ authentication: { signedOut: "failed" } }) && e({
      isSuccess: !1,
      isError: !0,
      error: r.context.errors.authentication || null,
      user: null,
      accessToken: null
    });
  });
}), ze = (s, e, t) => new Promise((r) => {
  const { changed: n, context: i } = s.send("SIGNIN_PASSWORD", {
    email: e,
    password: t
  });
  if (!n)
    return r({
      accessToken: i.accessToken.value,
      error: v,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      needsMfaOtp: !1,
      mfa: null,
      user: i.user
    });
  s.onTransition((c) => {
    c.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? r({
      accessToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      needsMfaOtp: !1,
      mfa: null,
      user: null
    }) : c.matches({ authentication: { signedOut: "needsMfa" } }) ? r({
      accessToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !1,
      needsMfaOtp: !0,
      mfa: c.context.mfa,
      user: null
    }) : c.matches({ authentication: { signedOut: "failed" } }) ? r({
      accessToken: null,
      error: c.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      needsMfaOtp: !1,
      mfa: null,
      user: null
    }) : c.matches({ authentication: "signedIn" }) && r({
      accessToken: c.context.accessToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      needsMfaOtp: !1,
      mfa: null,
      user: c.context.user
    });
  });
}), X = (s, e, t) => new Promise((r) => {
  const { changed: n } = s.send("PASSWORDLESS_EMAIL", {
    email: e,
    options: t
  });
  if (!n)
    return r({
      error: v,
      isError: !0,
      isSuccess: !1
    });
  s.onTransition((i) => {
    i.matches("registration.incomplete.failed") ? r({
      error: i.context.errors.registration || null,
      isError: !0,
      isSuccess: !1
    }) : i.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) && r({ error: null, isError: !1, isSuccess: !0 });
  });
}), Be = (s, e) => new Promise((t) => {
  const { changed: r, context: n } = s.send({ type: "SIGNIN_SECURITY_KEY_EMAIL", email: e });
  if (!r)
    return t({
      accessToken: n.accessToken.value,
      error: v,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: n.user
    });
  s.onTransition((i) => {
    i.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? t({
      accessToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      user: null
    }) : i.matches({ authentication: { signedOut: "failed" } }) ? t({
      accessToken: null,
      error: i.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: null
    }) : i.matches({ authentication: "signedIn" }) && t({
      accessToken: i.context.accessToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      user: i.context.user
    });
  });
}), Fe = (s, e, t) => new Promise((r) => {
  const { changed: n, context: i } = s.send("SIGNIN_MFA_TOTP", {
    otp: e,
    ticket: t
  });
  if (!n)
    return r({
      accessToken: i.accessToken.value,
      error: v,
      isError: !0,
      isSuccess: !1,
      user: i.user
    });
  s.onTransition((c) => {
    c.matches({ authentication: { signedOut: "failed" } }) ? r({
      accessToken: null,
      error: c.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      user: null
    }) : c.matches({ authentication: "signedIn" }) && r({
      accessToken: c.context.accessToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      user: c.context.user
    });
  });
}), J = (s, e, t) => new Promise((r) => {
  const { changed: n } = s.send("PASSWORDLESS_SMS", { phoneNumber: e, options: t });
  if (!n)
    return r({
      error: v,
      isError: !0,
      isSuccess: !1,
      needsOtp: !1
    });
  s.onTransition((i) => {
    i.matches("registration.incomplete.needsOtp") ? r({
      error: null,
      isError: !1,
      isSuccess: !1,
      needsOtp: !0
    }) : i.matches("registration.incomplete.failed") && r({
      error: i.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      needsOtp: !1
    });
  });
}), Qe = (s, e, t) => new Promise((r) => {
  const { changed: n } = s.send({ type: "PASSWORDLESS_SMS_OTP", phoneNumber: e, otp: t });
  if (!n)
    return r({
      error: v,
      isError: !0,
      isSuccess: !1,
      user: null,
      accessToken: null
    });
  s.onTransition((i) => {
    i.matches({ authentication: "signedIn" }) ? r({
      error: null,
      isError: !1,
      isSuccess: !0,
      user: i.context.user,
      accessToken: i.context.accessToken.value
    }) : i.matches({ registration: { incomplete: "failed" } }) && r({
      error: i.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      user: null,
      accessToken: null
    });
  });
}), Xe = async (s, e) => new Promise((t) => {
  const { event: r } = s.send("SIGNOUT", { all: e });
  if (r.type !== "SIGNED_OUT")
    return t({ isSuccess: !1, isError: !0, error: Te });
  s.onTransition((n) => {
    n.matches({ authentication: { signedOut: "success" } }) ? t({ isSuccess: !0, isError: !1, error: null }) : n.matches("authentication.signedOut.failed") && t({ isSuccess: !1, isError: !0, error: n.context.errors.signout || null });
  });
}), Z = (s, e, t, r) => new Promise((n) => {
  const { changed: i, context: c } = s.send("SIGNUP_EMAIL_PASSWORD", {
    email: e,
    password: t,
    options: r
  });
  if (!i)
    return n({
      error: v,
      accessToken: c.accessToken.value,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: c.user
    });
  s.onTransition((l) => {
    l.matches("registration.incomplete.failed") ? n({
      accessToken: null,
      error: l.context.errors.registration || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: null
    }) : l.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? n({
      accessToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      user: null
    }) : l.matches({ authentication: "signedIn", registration: "complete" }) && n({
      accessToken: l.context.accessToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      user: l.context.user
    });
  });
}), Je = (s, e, t) => new Promise((r) => {
  const { changed: n, context: i } = s.send("SIGNUP_SECURITY_KEY", {
    email: e,
    options: t
  });
  if (!n)
    return r({
      error: v,
      accessToken: i.accessToken.value,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: i.user
    });
  s.onTransition((c) => {
    c.matches("registration.incomplete.failed") ? r({
      accessToken: null,
      error: c.context.errors.registration || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: null
    }) : c.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? r({
      accessToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      user: null
    }) : c.matches({ authentication: "signedIn", registration: "complete" }) && r({
      accessToken: c.context.accessToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      user: c.context.user
    });
  });
});
class cr {
  constructor({
    url: e,
    autoRefreshToken: t = !0,
    autoSignIn: r = !0,
    autoLogin: n,
    clientStorage: i,
    clientStorageType: c,
    clientStorageGetter: l,
    clientStorageSetter: m,
    refreshIntervalTime: g,
    start: p = !0
  }) {
    var k;
    this.url = e, this._client = new ae({
      backendUrl: e,
      clientUrl: typeof window < "u" && ((k = window.location) == null ? void 0 : k.origin) || "",
      autoRefreshToken: t,
      autoSignIn: typeof n == "boolean" ? n : r,
      start: p,
      clientStorage: i,
      clientStorageType: c,
      clientStorageGetter: l,
      clientStorageSetter: m,
      refreshIntervalTime: g
    });
  }
  async signUp(e) {
    const t = await this.waitUntilReady(), { email: r, options: n } = e;
    return "securityKey" in e ? _(
      await Je(t, r, n)
    ) : _(
      await Z(t, r, e.password, n)
    );
  }
  async signIn(e) {
    const t = await this.waitUntilReady();
    if (!e) {
      const r = await Ye(t);
      return { ..._(r), mfa: null };
    }
    if ("provider" in e) {
      const { provider: r, options: n } = e, i = oe(
        `${this._client.backendUrl}/signin/provider/${r}`,
        y(this._client.clientUrl, n)
      );
      return W() && (window.location.href = i), { providerUrl: i, provider: r, session: null, mfa: null, error: null };
    }
    if ("email" in e && "password" in e) {
      const r = await ze(t, e.email, e.password);
      return r.needsEmailVerification ? { session: null, mfa: null, error: ye } : r.needsMfaOtp ? {
        session: null,
        mfa: r.mfa,
        error: null
      } : { ..._(r), mfa: null };
    }
    if ("email" in e && "securityKey" in e) {
      if (e.securityKey !== !0)
        throw Error("securityKey must be true");
      const r = await Be(t, e.email);
      return { ..._(r), mfa: null };
    }
    if ("email" in e) {
      const { email: r, options: n } = e, { error: i } = await X(t, r, n);
      return {
        session: null,
        mfa: null,
        error: i
      };
    }
    if ("phoneNumber" in e && "otp" in e) {
      const r = await Qe(t, e.phoneNumber, e.otp);
      return { ..._(r), mfa: null };
    }
    if ("phoneNumber" in e) {
      const { error: r } = await J(
        t,
        e.phoneNumber,
        e.options
      );
      return { error: r, mfa: null, session: null };
    }
    if ("otp" in e) {
      const r = await Fe(t, e.otp, e.ticket);
      return { ..._(r), mfa: null };
    }
    return { error: ke, mfa: null, session: null };
  }
  async signOut(e) {
    const t = await this.waitUntilReady(), { error: r } = await Xe(t, e == null ? void 0 : e.all);
    return { error: r };
  }
  async resetPassword({ email: e, options: t }) {
    const r = P(Ve(this._client)).start(), { error: n } = await je(r, e, t);
    return { error: n };
  }
  async changePassword({
    newPassword: e,
    ticket: t
  }) {
    const r = P(Ke(this._client)).start(), { error: n } = await We(r, e, t);
    return { error: n };
  }
  async sendVerificationEmail({
    email: e,
    options: t
  }) {
    const r = P(Ge(this._client)).start(), { error: n } = await He(r, e, t);
    return { error: n };
  }
  async changeEmail({ newEmail: e, options: t }) {
    const r = P(Me(this._client)).start(), { error: n } = await $e(r, e, t);
    return { error: n };
  }
  async deanonymize(e) {
    const t = await this.waitUntilReady();
    if (e.signInMethod === "passwordless") {
      if (e.connection === "email") {
        const { error: r } = await X(
          t,
          e.email,
          e.options
        );
        return { error: r };
      }
      if (e.connection === "sms") {
        const { error: r } = await J(
          t,
          e.phoneNumber,
          e.options
        );
        return { error: r };
      }
    }
    if (e.signInMethod === "email-password") {
      const { error: r } = await Z(
        t,
        e.email,
        e.password,
        e.options
      );
      return { error: r };
    }
    throw Error("Unknown deanonymization method");
  }
  async addSecurityKey(e) {
    const { error: t, key: r } = await qe(this._client, e);
    return { error: t, key: r };
  }
  onTokenChanged(e) {
    return this._client.subscribe(() => {
      var r;
      const t = (r = this._client.interpreter) == null ? void 0 : r.onTransition(({ event: n, context: i }) => {
        n.type === "TOKEN_CHANGED" && e(x(i));
      });
      return () => t == null ? void 0 : t.stop();
    });
  }
  onAuthStateChanged(e) {
    return this._client.subscribe(() => {
      var r;
      const t = (r = this._client.interpreter) == null ? void 0 : r.onTransition(({ event: n, context: i }) => {
        (n.type === "SIGNED_IN" || n.type === "SIGNED_OUT") && e(n.type, x(i));
      });
      return () => t == null ? void 0 : t.stop();
    });
  }
  isAuthenticated() {
    var e;
    return !!((e = this._client.interpreter) != null && e.getSnapshot().matches({ authentication: "signedIn" }));
  }
  async isAuthenticatedAsync() {
    return (await this.waitUntilReady()).getSnapshot().matches({ authentication: "signedIn" });
  }
  getAuthenticationStatus() {
    var t;
    const e = ((t = this.client.interpreter) == null ? void 0 : t.getSnapshot().context.importTokenAttempts) || 0;
    return this.isReady() ? { isAuthenticated: this.isAuthenticated(), isLoading: !1, connectionAttempts: e } : {
      isAuthenticated: !1,
      isLoading: !0,
      connectionAttempts: e
    };
  }
  getJWTToken() {
    return this.getAccessToken();
  }
  getAccessToken() {
    var e;
    return ((e = this._client.interpreter) == null ? void 0 : e.getSnapshot().context.accessToken.value) ?? void 0;
  }
  getDecodedAccessToken() {
    const e = this.getAccessToken();
    return e ? ue(e) : null;
  }
  getHasuraClaims() {
    var e;
    return ((e = this.getDecodedAccessToken()) == null ? void 0 : e["https://hasura.io/jwt/claims"]) || null;
  }
  getHasuraClaim(e) {
    var t;
    return ((t = this.getHasuraClaims()) == null ? void 0 : t[e.startsWith("x-hasura-") ? e : `x-hasura-${e}`]) || null;
  }
  async refreshSession(e) {
    try {
      const t = await this.waitUntilReady();
      return new Promise((r) => {
        const n = e || t.getSnapshot().context.refreshToken.value;
        if (!n)
          return r({ session: null, error: pe });
        const { changed: i } = t.send("TRY_TOKEN", { token: n });
        if (!i)
          return r({ session: null, error: we });
        t.onTransition((c) => {
          c.matches({ token: { idle: "error" } }) ? r({
            session: null,
            error: Se
          }) : c.event.type === "TOKEN_CHANGED" && r({ session: x(c.context), error: null });
        });
      });
    } catch (t) {
      return { session: null, error: t.message };
    }
  }
  getSession() {
    var e, t;
    return x((t = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot()) == null ? void 0 : t.context);
  }
  getUser() {
    var e, t, r;
    return ((r = (t = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot()) == null ? void 0 : t.context) == null ? void 0 : r.user) || null;
  }
  waitUntilReady() {
    const t = this._client.interpreter;
    if (!t)
      throw Error("Auth interpreter not set");
    return t.getSnapshot().hasTag("loading") ? new Promise((r, n) => {
      let i = setTimeout(
        () => n(`The state machine is not yet ready after ${15} seconds.`),
        15e3
      );
      t.onTransition((c) => {
        if (!c.hasTag("loading"))
          return clearTimeout(i), r(t);
      });
    }) : Promise.resolve(t);
  }
  isReady() {
    var e, t;
    return !((t = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot()) != null && t.hasTag("loading"));
  }
  get client() {
    return this._client;
  }
}
export {
  ae as AuthClient,
  ir as AuthClientSSR,
  Le as AuthCookieClient,
  M as CodifiedError,
  ye as EMAIL_NEEDS_VERIFICATION,
  cr as HasuraAuthClient,
  L as INITIAL_MACHINE_CONTEXT,
  A as INVALID_EMAIL_ERROR,
  me as INVALID_MFA_CODE_ERROR,
  Ee as INVALID_MFA_TICKET_ERROR,
  fe as INVALID_MFA_TYPE_ERROR,
  $ as INVALID_PASSWORD_ERROR,
  B as INVALID_PHONE_NUMBER_ERROR,
  Se as INVALID_REFRESH_TOKEN,
  ke as INVALID_SIGN_IN_METHOD,
  de as MIN_PASSWORD_LENGTH,
  ee as NETWORK_ERROR_CODE,
  D as NHOST_JWT_EXPIRES_AT_KEY,
  N as NHOST_REFRESH_TOKEN_KEY,
  ge as NO_MFA_TICKET_ERROR,
  pe as NO_REFRESH_TOKEN,
  re as OTHER_ERROR_CODE,
  z as REFRESH_TOKEN_MAX_ATTEMPTS,
  C as STATE_ERROR_CODE,
  we as TOKEN_REFRESHER_RUNNING_ERROR,
  he as TOKEN_REFRESH_MARGIN,
  v as USER_ALREADY_SIGNED_IN,
  sr as USER_NOT_ANONYMOUS,
  Te as USER_UNAUTHENTICATED,
  S as VALIDATION_ERROR_CODE,
  ar as activateMfaPromise,
  qe as addSecurityKeyPromise,
  $e as changeEmailPromise,
  We as changePasswordPromise,
  Ue as createAuthMachine,
  Me as createChangeEmailMachine,
  Ke as createChangePasswordMachine,
  nr as createEnableMfaMachine,
  Ve as createResetPasswordMachine,
  Ge as createSendVerificationEmailMachine,
  oe as encodeQueryParameters,
  or as generateQrCodePromise,
  _ as getAuthenticationResult,
  U as getParameterByName,
  x as getSession,
  W as isBrowser,
  I as isValidEmail,
  j as isValidPassword,
  Q as isValidPhoneNumber,
  xe as isValidTicket,
  Ne as localStorageGetter,
  De as localStorageSetter,
  b as nhostApiClient,
  F as removeParameterFromWindow,
  je as resetPasswordPromise,
  y as rewriteRedirectTo,
  He as sendVerificationEmailPromise,
  Ye as signInAnonymousPromise,
  ze as signInEmailPasswordPromise,
  X as signInEmailPasswordlessPromise,
  Be as signInEmailSecurityKeyPromise,
  Fe as signInMfaTotpPromise,
  Qe as signInSmsPasswordlessOtpPromise,
  J as signInSmsPasswordlessPromise,
  Xe as signOutPromise,
  Z as signUpEmailPasswordPromise,
  Je as signUpEmailSecurityKeyPromise
};
//# sourceMappingURL=index.esm.js.map
